const PRODUCTS_PLACEHOLDER = '#number of products#';
const RANGES_PLACEHOLDER = '#number of ranges#';
const VIEW_ON_PLACEHOLDER = '#domain_name#';

export { PRODUCTS_PLACEHOLDER as P, RANGES_PLACEHOLDER as R, VIEW_ON_PLACEHOLDER as V };
